/**
 * cart-error-i18n.js
 *
 * The one-Pack-per-cart rule is enforced server-side: POST /cart/add.js comes
 * back 422 with {"message": "You may only purchase 1 Pack. "} and the theme
 * prints that straight into [data-error-display]. The string is owned by the
 * app that registered the cart validation, not by this theme, so it arrives in
 * English no matter what language the customer is browsing in.
 *
 * The theme sends cart requests through a bundled axios (no global to hook) and
 * XMLHttpRequest.responseText can't be rewritten cleanly, so instead of
 * intercepting the response this watches the error containers and swaps the
 * sentence for the translated one as it is written. The replacement happens in
 * the same microtask as the DOM write, before paint.
 *
 * If the app's wording ever changes, update PATTERN — a miss just means the
 * original English shows, which is the behaviour we have today.
 */
(function () {
  'use strict';

  var translated = (window.cartLimitStrings || {}).serverPackLimit;
  if (!translated) return;

  var PATTERN = /you\s+may\s+only\s+purchase\s+\d+\s+pack/i;

  function swap(el) {
    if (!el || el.nodeType !== 1) return;
    var text = el.textContent;
    if (!PATTERN.test(text)) return;
    if (text.trim() === translated) return; // already done — avoids a mutation loop
    var leaves = [].slice.call(el.querySelectorAll('*')).filter(function (n) {
      return n.children.length === 0 && PATTERN.test(n.textContent);
    });
    if (!leaves.length && el.children.length === 0) leaves = [el];
    leaves.forEach(function (leaf) {
      if (leaf.textContent.trim() !== translated) leaf.textContent = translated;
    });
  }

  function scan(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.matches && node.matches('[data-error-display]')) swap(node);
    if (node.querySelectorAll) {
      [].slice.call(node.querySelectorAll('[data-error-display]')).forEach(swap);
    }
    var holder = node.closest && node.closest('[data-error-display]');
    if (holder) swap(holder);
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.type === 'characterData') {
        scan(m.target.parentElement);
        return;
      }
      scan(m.target);
      [].slice.call(m.addedNodes).forEach(scan);
    });
  });

  function start() {
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
    });
    scan(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
